// extracted by mini-css-extract-plugin
export default {"button":"checkboxes__button__B9","icon":"checkboxes__icon__pd","only":"checkboxes__only__vr description"};